import React, {useEffect} from 'react';
import { Paper, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {useHistory} from "react-router-dom";
import moment from "moment";
import Button from "@material-ui/core/Button";
import {confirmInterpretation, getInterpretationById, getInterpretationOrderById, rejectInterpretation} from "../api";

const useStyles = makeStyles((theme) => ({
 card: {
  padding: theme.spacing(2),
  borderRadius: 8,
  border: '1px solid #ccc',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  minWidth: 280,
  margin: '4px 0px'
 },
 header: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: '0.8rem',
 },
 activeDot: {
  display: 'flex',
  alignItems: 'center',
  color: '#34A853',
  fontWeight: 500,
  gap: 6,
 },
 checkIcon: {
  width: '20px',
  height: '10px',
  borderRadius: '10px',
  background: '#34A853',
 },
 patientName: {
  fontWeight: 600,
  fontSize: '1rem',
 },
 orderNumber: {
  fontSize: '0.9rem',
  color: '#555',
 },
 testList: {
  fontSize: '0.85rem',
  color: '#333',
  whiteSpace: 'pre-line',
 },
 goodsArr: {
  color: '#A1AAB2',
 },
 buttonsBox: {
  display: 'grid',
  // justifyContent: 'space-between',
  gridTemplateColumns: '1fr 1fr',
  marginTop: theme.spacing(1),
  gap: '10px'
 },
 buttonRed: {
  border: '1px solid #e53935',
  color: '#e53935',
  backgroundColor: '#fff',
  textTransform: 'none',
  borderRadius: '6px',
  '&:hover': {
   backgroundColor: '#fcebea',
  },
 },
 buttonBlue: {
  backgroundColor: '#1976d2',
  textTransform: 'none',
  borderRadius: '6px',
  whiteSpace: 'nowrap',
  color: '#fff',
  '&:hover': {
   backgroundColor: '#115293',
  },
 },
}));

const PatientDetail = ({order}) => {
 const classes = useStyles();
 const patient = order.patient
 const pdom = order.pdom

 return  <Box>
  <Typography className={classes.testList}>
   <b>Стать:</b> {patient?.gender === 'F' ? 'Жінка' : patient?.gender === 'M' ? 'Чоловік' : ''}
  </Typography>
  <Typography className={classes.testList}>
   <b>ДН:</b> {patient.dt}
  </Typography>
  <Typography className={classes.testList}>
   <b>Вік:</b> {moment().clone().diff(patient.dt, "years")} років
  </Typography>
  {(patient?.gender === 'F') && !!pdom?.odm && <Typography className={classes.testList}>
   <b>Останній день місячних:</b> {pdom?.odm}
  </Typography>}
  {(patient?.gender === 'F') && !!pdom?.weekp && <Typography className={classes.testList}>
   <b>Тиждень вагітності:</b> {pdom?.weekp}
  </Typography>}
  {(patient?.gender === 'F') && !!pdom?.fetus && (+pdom?.fetus > 0) && <Typography className={classes.testList}>
   <b>Кількість плодів:</b> {pdom?.fetus}
  </Typography>}
  {(patient?.gender === 'F') && !!pdom?.menopausa && <Typography className={classes.testList}>
   <b>Менопауза:</b> {pdom?.menopausa}
  </Typography>}
  {!!pdom?.weight && (+pdom?.weight > 0) && <Typography className={classes.testList}>
   <b>Вага:</b> {pdom?.weight}
  </Typography>}
  {!!pdom?.height && (+pdom?.height > 0) && <Typography className={classes.testList}>
   <b>Ріст:</b> {pdom?.height}
  </Typography>}
  {(patient?.gender !== 'F') && !!pdom?.prostate && <Typography className={classes.testList}>
   <b>Простата:</b> {pdom?.prostate}
  </Typography>}
  {!!pdom?.urine && (+pdom?.urine > 0) && <Typography className={classes.testList}>
   <b>К-сть сечі:</b> {pdom?.urine}
  </Typography>}
  {!!pdom?.localization && <Typography className={classes.testList}>
   <b>Локалізація:</b> {pdom?.localization}
  </Typography>}
 </Box>
}

const OrderStatus = ({order}) => {
 const classes = useStyles();
 const notPaid = order.options.includes("approved") && !order.options.includes("payed")
 const [state, setState] = React.useState({
  color: '#34A853',
  text: 'Активне'
 })

 useEffect(() => {
  if (notPaid) {
   setState(p=>({
    ...p,
    color: '#DB7663',
    text: 'Не оплачене'
   }))
  } else if (order.options.includes("payed") && !order.options.includes("done")) {
   setState(p=>({
    ...p,
    color: '#E4B53D',
    text: 'Оплачене'
   }))
  } else if (order.options.includes("done")) {
   setState(p=>({
    ...p,
    color: '#34A853',
    text: 'Готовий результат'
   }))
  }

 }, [order]);

 return <div className={classes.activeDot} style={{color: state.color}}>
  <div className={classes.checkIcon} style={{background: state.color}}/>
  {state.text}
 </div>
}

const OrderDetails = ({order, goods = true, patient = false, handleConfirm, handleReject, handleGetOrders}) => {
 const classes = useStyles();
 const history = useHistory()
 const [showButtons, setShowButtons] = React.useState(false)

 const handleClick = (e,order) => {
  e.preventDefault();
  e.stopPropagation();

  history.push(`/doctor-interpretation/${order.id}`)
 }


 const handleSetConfirm = async (event) => {
  if (handleConfirm) {
   setShowButtons(false)

   await handleConfirm(event)
   return
  }
  event.stopPropagation()
  event.preventDefault()
  try {
   setShowButtons(false)
   await confirmInterpretation(order.id)

   const orderRes = await getInterpretationById(order.id)

   await getInterpretationOrderById(orderRes.orderId)
  } catch (e) {
   console.error(e)
  }
  if (handleGetOrders) {
   handleGetOrders()
  }
  handleClick(event,order)
 }

 const handleSetReject = async (event) => {
  event.stopPropagation()
  event.preventDefault()

  if (handleReject) {
   setShowButtons(false)

   await handleReject(event)
   return
  }

  try {
   setShowButtons(false)
   await rejectInterpretation(order.id)

   const orderRes = await getInterpretationById(order.id)

   await getInterpretationOrderById(orderRes?.orderId)
  } catch (e) {
   console.error(e)
  }

  if (handleGetOrders) {
   handleGetOrders()
  }
 }

 useEffect(() => {
  if (!order.options.includes("approved")) {
   setShowButtons(true)
  }
 }, [order]);
 return (
  <Paper className={classes.card} onClick={(e)=>handleClick(e,order)}>
   <Box className={classes.header}>
    <OrderStatus order={order}/>
   </Box>

   <Typography className={classes.patientName}>
    {order.patient.lastname || ''} {order.patient.firstname || ''} {order.patient.fathername || ''}
   </Typography>

   <Typography className={classes.orderNumber}>
    <span className={classes.goodsArr}>Замовлення №: </span>
    <br/>
    <b>{order.id || ''}</b>
   </Typography>

   {patient && <PatientDetail order={order}/>}
    {goods && <Typography className={classes.testList}>
    <b>Містить дослідження:</b>
    <br/>
    <span className={classes.goodsArr}>{order.goods.map(good => (good?.name || '') + ' / ')}</span>
   </Typography>}

   {showButtons && <Box className={classes.buttonsBox}>
    <Button
     variant="outlined"
     className={classes.buttonRed}
     onClick={handleSetReject}
    >
     Відхилити
    </Button>
    <Button
     variant="contained"
     className={classes.buttonBlue}
     onClick={handleSetConfirm}
    >
     Беру в роботу
    </Button>
   </Box>}
  </Paper>
 );
};

export default OrderDetails;
